<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="row" id="divTop" style="margin-top: 10px;margin-bottom: 10px;">
        <div class="col-md-9 col-xs-9">
          <div id="ButtonsTab" style="padding-left:5px;">
            <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary"
              (click)="SubmitFinanceUserMapping();"  *ngIf="this.FinanceUserMappingList.ID == 0">
              <span>Submit</span>
            </button>
             <button id="btnSubmit" type="button" title="Update" class="btn btn-primary"
              (click)="SubmitFinanceUserMapping();" *ngIf="this.FinanceUserMappingList.ID != 0">
              <span>Update</span>
            </button>
            <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit()">
              <span>Exit</span>
            </button>

          </div>
        </div>
        <div class="col-md-3 col-xs-3" style="padding-right: 0px;">
          <div style="text-align: right;padding-right:5px;margin-top:20px;">
            <h6 style="color: #808080; font-size: 13px; font-style: oblique; font-weight:bold;"></h6>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.Message}}</span>
          </div>
        </div>
      </div>
      <div class="current-compensation-wrapper">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Finance User Mapping</b>
            </a>
          </h4>
        </div>
        <div style="height: 500px;">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Employee Name</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <p-autoComplete [(ngModel)]="EmployeeList.Employee" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                                        (completeMethod)="GetEmpSearch($event,false)" field="EmpFullName" [size]="30"
                                        placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="Employee" (onClear)="OnClearSendUser()" (onSelect)="SetSelectedEmpGPN($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>

                    </div>
                  </div>
                </div>
                </div>
                 <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Service Line</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <mat-select [(ngModel)]="FinanceUserMappingList.ServiceLine" class="form-control"  placeholder="Please Select Service Line" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option *ngFor="let option of ServiceLineList" [value]="option.SL">
                          {{ option.SL }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Competency</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <mat-select [(ngModel)]="FinanceUserMappingList.Competency" class="form-control"  placeholder="Please Select Competency" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option [value]="-1">All</mat-option>
                        <mat-option *ngFor="let option of CompetencyList" [value]="option.CompetencyCode" >
                          {{ option.CompetencyName }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="col-md-6">
                <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Employee GPN</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                       <input type="text" id="txtEmployeeGPN" name="txtEmployeeGPN" maxlength="200" placeholder="Employee GPN"
                                 class="form-control" [(ngModel)]="FinanceUserMappingList.EmployeeGPN" autocomplete="off"
                         (keypress)="blockSpecialChar($event)" #txtEmployeeGPN="ngModel" pattern="^[a-zA-Z0-9\s]*$" readonly>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>MS</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <mat-select [(ngModel)]="FinanceUserMappingList.MargentSegment" class="form-control"  placeholder="Please Select MS" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option *ngFor="let option of MargentSegmentList" [value]="option.MarketSegment">
                          {{ option.MarketSegment }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>
                </div>
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Is Active</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <mat-checkbox [(ngModel)]="FinanceUserMappingList.IsActive"></mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
  </div>
</div>

<div *ngIf="isLoading" class="overlay">
  <p-progressSpinner styleClass="spinner" [style]="{width: '100px', height: '100px'}"></p-progressSpinner>
</div>
